<div class="d-flex justify-content-center">
  <div class="card w-100 border-0">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <ng-container *ngIf="response() as response">
            <app-shared-table [items]="sharedtableConfig()" [enablePagination]="true" [enableSorting]="false"
              [initialPageSize]="response.paginationMetadata.pageSize"
              [totalRecords]="response.paginationMetadata.totalItemCount" [bodyTemplate]="customBodyTemplate"
              (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"
              (search)="onSearch($event)" [customTemplate]="true"
              [HandelRenderingDataMessage]="handelRenderingDataMessage()" [page]="currentPage()" [size]="pageSize()"
              [showBtn]="createActionManger()?.canUse() ?? false"
              (buttonClick)="createActionManger()?.execute(undefined, selfActionExecuted)"
              [buttonText]="(createActionManger()?.config?.label ?? '' | translate) ?? ('ACTIONS.CREATE_NEW_ITEM' | translate)"
              [showFilterBtn]="showFilterBtn()" [filterOptions]="filterOptions() || []"
              [sidebarVisible]="sidebarVisible()" (sidebarVisibleChange)="onSidebarVisibleChange($event)"
              (applyFilter)="onApplyFilter($event)" (clearFilter)="onClearFilter()">
            </app-shared-table>
            <ng-template #customBodyTemplate let-element>
              @if (!isLoading()) {
              <tr>
                <ng-container *ngIf="tableManager().template; else defaultTemplate">
                  <ng-container
                    *ngTemplateOutlet="tableManager().template; context: { $implicit: element }"></ng-container>
                </ng-container>
                <ng-template #defaultTemplate let-element></ng-template>

                <td *ngIf="actionsManager().canUseAny()">
                  <app-table-actions [entity]="element" [supportedActions]="supportedActions()" (updated)="onUpdated()"
                    (actionExecuted)="onActionExecuted($event)" />
                </td>
              </tr>
              }
              @if (isLoading()) {
              <tr>
                @for (item of sharedtableConfig().dataKeys; track $index) {
                <td><p-skeleton /></td>
                }
                <td><p-skeleton /></td>
              </tr>
              }
            </ng-template>
          </ng-container>
          @if (!response()) {
          <div class="row mb-4">
            <div class="col-md-5">
              <p-skeleton width="100%" height="35px" class="d-block" />
            </div>
            <div class="col-md-4 offset-md-3">
              <p-skeleton width="100%" height="35px" class="d-block" />
            </div>
          </div>
          @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
          <p-skeleton width="100%" height="35px" class="mb-2 d-block" />
          }
          }
        </div>
      </div>
    </div>
  </div>
</div>
